/* unplugin-vue-components disabled */import script from "./Kycg.vue?vue&type=script&lang=ts&setup=true"
export * from "./Kycg.vue?vue&type=script&lang=ts&setup=true"

import "./Kycg.vue?vue&type=style&index=0&id=20e99b6a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e99b6a"]])

export default __exports__